import axios from 'axios'

const getAll = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/customer/admin/blocked`)
  return data
}

const getLogs = async (userId) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/customer/admin/blocked/${userId}/logs`)
  return data
}

const unblock = async (userId) => {
  const { data } = await axios.put(`${process.env.VUE_APP_API}/customer/admin/unblock/${userId}`)
  return data
}

export {
  getAll,
  getLogs,
  unblock
}
